
'use strict';

import Rule from './Rule.js';
import Hint from './Hint.js';
import KeyValueCache     from './../../Utils/KeyValueCache';


/**
 * Currently hardcoded rules
 * 
 * @param string value
 * @param string display
 * @return void
 */
var AnswerHintsFromMentalStatus = function ( ) {
  
  var matchingRules = [];

  var cachedAnswers = [];
  
  var cachedHints =  new KeyValueCache();

  /**
   * Get hard coded rules
   * 
   * @return array
   */
  var loadRules = function( item ) {matchingRules.push( new Rule( 'A', '1.1.1.a.1', [ 'Q.4.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.1.a.1', [ 'Q.4.a.1' ] ) );
  matchingRules.push( new Rule( 'NAE', '1.1.1.a.1', [ 'Q.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.1.a.2', [ 'Q.3.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.1.a.2', [ 'Q.3.a.1' ] ) );
  matchingRules.push( new Rule( 'NAE', '1.1.1.a.2', [ 'Q.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.1.a.3', [ 'Q.2.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.1.a.3', [ 'Q.2.a.1' ] ) );
  matchingRules.push( new Rule( 'NAE', '1.1.1.a.3', [ 'Q.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.1.a.4', [ 'Q.1.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.1.a.4', [ 'Q.1.a.1' ] ) );
  matchingRules.push( new Rule( 'NAE', '1.1.1.a.4', [ 'Q.1.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.1', [ 'S.1.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.4.a.1', [ 'S.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.2', [ 'H.2.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.4.a.2', [ 'H.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.3', [ 'R.11.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.4.a.3', [ 'R.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.4', [ 'R.11.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.4.a.4', [ 'R.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.5', [ 'R.1.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.4.a.5', [ 'R.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.6', [ 'R.13.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.4.a.6', [ 'R.13.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.7', [ 'R.12.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.4.a.7', [ 'R.12.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.8', [ 'R.13.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.4.a.8', [ 'R.13.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.9', [ 'R.3.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.4.a.9', [ 'R.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.10', [ 'R.1.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.4.a.10', [ 'R.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.11', [ 'R.7.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.4.a.11', [ 'R.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.12', [ 'E.1.a.2' , 'E.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.4.a.13', [ 'E.4.a.1' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.4.a.13', [ 'E.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.7.a.1', [ 'B.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.7.a.2', [ 'B.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.7.a.3', [ 'B.1.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.8.a.1', [ 'P.5.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.8.a.1', [ 'P.4.a.1' ] ) );
  matchingRules.push( new Rule( 'NAE', '1.1.8.a.1', [ 'P.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.8.a.2', [ 'P.5.a.3' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.8.a.2', [ 'P.4.a.1' ] ) );
  matchingRules.push( new Rule( 'NAE', '1.1.8.a.2', [ 'P.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.8.a.3', [ 'P.5.a.4' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.8.a.3', [ 'P.4.a.1' ] ) );
  matchingRules.push( new Rule( 'NAE', '1.1.8.a.3', [ 'P.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.8.a.4', [ 'P.5.a.5' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.8.a.4', [ 'P.4.a.1' ] ) );
  matchingRules.push( new Rule( 'NAE', '1.1.8.a.4', [ 'P.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.9.a.1', [ 'P.1.a.3' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.9.a.1', [ 'P.1.a.1' ] ) );
  matchingRules.push( new Rule( 'NAE', '1.1.9.a.1', [ 'P.1.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.9.a.2', [ 'P.2.a.3' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.9.a.2', [ 'P.2.a.1' ] ) );
  matchingRules.push( new Rule( 'NAE', '1.1.9.a.2', [ 'P.2.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.9.a.3', [ 'P.3.a.3' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.9.a.3', [ 'P.3.a.1' ] ) );
  matchingRules.push( new Rule( 'NAE', '1.1.9.a.3', [ 'P.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.10.a.1', [ 'F.8.a.1' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.10.a.1', [ 'F.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.10.a.2', [ 'F.6.a.9' , 'D.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.10.a.3', [ 'F.6.a.3' , 'D.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.10.a.5', [ 'F.8.a.4' , 'F.8.a.3' , 'F.8.a.5' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.10.a.5', [ 'F.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.10.a.6', [ 'G.3.a.1' , 'G.3.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.10.a.6', [ 'G.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.10.a.7', [ 'D.2.a.4' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.10.a.7', [ 'D.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.11.a.1', [ 'E.1.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.11.a.1', [ 'E.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.11.a.2', [ 'E.3.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.11.a.2', [ 'E.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.11.a.4', [ 'R.5.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.11.a.4', [ 'R.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.11.a.5', [ 'R.7.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.11.a.5', [ 'R.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.11.a.6', [ 'R.3.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.11.a.6', [ 'R.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.13.a.3', [ 'G.17.a.1' , 'G.17.a.3' , 'G.6.a.1' , 'G.6.a.2' , 'G.6.a.3' , 'G.6.a.4' , 'G.13.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.13.a.4', [ 'G.19.a.1' , 'G.19.a.2' , 'G.19.a.3' , 'G.19.a.4' , 'G.19.a.5' , 'G.19.a.7' , 'G.19.a.8' , 'G.19.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.13.a.6', [ 'G.17.a.7' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.13.a.6', [ 'G.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.14.a.1', [ 'G.17.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.14.a.1', [ 'G.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.14.a.2', [ 'G.13.a.6' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.14.a.2', [ 'G.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.14.a.3', [ 'G.17.a.1' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.14.a.3', [ 'G.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.15.a.1', [ 'G.17.a.1' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.15.a.1', [ 'G.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.15.a.2', [ 'G.6.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.15.a.2', [ 'G.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.15.a.3', [ 'G.13.a.6' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.15.a.3', [ 'G.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.15.a.4', [ 'G.19.a.2' , 'G.19.a.3' , 'G.19.a.4' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.15.a.4', [ 'G.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.16.a.2', [ 'G.17.a.1' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.16.a.2', [ 'G.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.16.a.3', [ 'G.19.a.2' , 'G.19.a.3' , 'G.19.a.4' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.16.a.3', [ 'G.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.16.a.4', [ 'G.19.a.1' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.16.a.4', [ 'G.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.17.a.1', [ 'G.2.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.17.a.1', [ 'G.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.17.a.2', [ 'G.2.a.1' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.17.a.2', [ 'G.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.17.a.3', [ 'G.2.a.3' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.17.a.3', [ 'G.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.17.a.4', [ 'G.5.a.6' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.17.a.4', [ 'G.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.17.a.5', [ 'C.2.a.1' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.17.a.5', [ 'G.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.17.a.6', [ 'C.2.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.17.a.6', [ 'G.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.17.a.7', [ 'G.3.a.5' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.17.a.7', [ 'G.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.18.a.1', [ 'M.2.a.1' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.18.a.1', [ 'M.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.18.a.3', [ 'M.2.a.5' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.18.a.3', [ 'M.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.18.a.4', [ 'M.2.a.3' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.18.a.4', [ 'M.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.18.a.6', [ 'M.2.a.8' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.18.a.6', [ 'M.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.18.a.7', [ 'M.2.a.10' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.18.a.7', [ 'M.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.18.a.8', [ 'L.6.a.5' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.18.a.8', [ 'L.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.19.a.1', [ 'L.1.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.19.a.1', [ 'L.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.19.a.2', [ 'L.2.a.6' , 'L.2.a.7' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.19.a.2', [ 'L.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.1.19.a.3', [ 'L.2.a.1' , 'L.2.a.2' , 'L.2.a.3' , 'L.2.a.4' , 'L.2.a.5' ] ) );
  matchingRules.push( new Rule( 'D', '1.1.19.a.3', [ 'L.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.2.20.a.9', [ 'Q.8.a.2' ] ) );
  matchingRules.push( new Rule( 'D', '1.2.20.a.9', [ 'Q.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '1.2.20.a.10', [ 'S.4.a.1' , 'S.4.a.2' , 'S.4.a.3' , 'S.4.a.4' , 'S.4.a.5' ] ) );
  matchingRules.push( new Rule( 'D', '1.2.20.a.10', [ 'S.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.3.a.1.3', [ 'N.2.a.1' , 'N.2.a.2' , 'N.6.a.1' , 'N.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.5.a.1', [ 'N.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.5.a.3', [ 'N.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.5.a.4', [ 'N.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.5.a.5', [ 'N.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.5.a.6', [ 'N.5.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.5.a.7', [ 'N.5.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.5.a.8', [ 'N.5.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.5.a.10', [ 'N.5.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.5.a.11', [ 'N.5.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.1', [ 'D.2.a.1' , 'D.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.2', [ 'D.2.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.3', [ 'D.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.4', [ 'D.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.5', [ 'D.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.6', [ 'F.6.a.3' , 'D.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.7', [ 'B.4.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.8', [ 'F.8.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.9', [ 'F.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.10', [ 'M.14.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.11', [ 'D.3.a.3' , 'F.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.12', [ 'D.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.13', [ 'G.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.14', [ 'S.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.15', [ 'G.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.16', [ 'G.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.17', [ 'G.5.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.18', [ 'G.2.a.1' , 'G.2.a.2' , 'G.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.19', [ 'G.17.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.20', [ 'G.8.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.21', [ 'B.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.22', [ 'B.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.23', [ 'B.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.24', [ 'B.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.25', [ 'G.17.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.26', [ 'Q.1.a.2' , 'Q.2.a.2' , 'Q.3.a.2' , 'Q.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.27', [ 'Q.2.a.2' , 'Q.3.a.2' , 'Q.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.28', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.29', [ 'S.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.30', [ 'G.19.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.31', [ 'G.19.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.32', [ 'G.19.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.33', [ 'C.9.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.35', [ 'D.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.36', [ 'K.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.37', [ 'K.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.38', [ 'K.3.a.9' , 'K.3.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.39', [ 'L.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.40', [ 'L.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.41', [ 'L.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.42', [ 'L.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.43', [ 'L.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.44', [ 'L.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.50', [ 'I.8.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.51', [ 'I.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.52', [ 'I.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.53', [ 'I.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.55', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.59', [ 'I.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.60', [ 'I.6.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.61', [ 'M.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.62', [ 'I.8.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.63', [ 'I.8.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.64', [ 'M.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.67', [ 'M.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.9.a.68', [ 'M.2.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.1', [ 'G.17.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.2', [ 'F.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.3', [ 'D.3.a.3' , 'F.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.4', [ 'F.6.a.9' , 'D.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.5', [ 'G.3.a.1' , 'G.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.6', [ 'I.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.7', [ 'I.6.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.9', [ 'M.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.14', [ 'I.8.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.16', [ 'I.8.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.17', [ 'I.8.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.25', [ 'I.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.28', [ 'G.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.29', [ 'G.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.33', [ 'B.4.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.34', [ 'M.14.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.35', [ 'M.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.37', [ 'M.2.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.38', [ 'M.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.39', [ 'M.2.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.40', [ 'L.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.41', [ 'L.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.42', [ 'L.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.43', [ 'K.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.44', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.45', [ 'I.10.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.46', [ 'I.10.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.11.a.47', [ 'G.17.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.12.a.1', [ 'B.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.13.a.1', [ 'P.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.13.a.2', [ 'P.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.13.a.3', [ 'P.5.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.13.a.4', [ 'P.5.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.14.a.1', [ 'Q.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.14.a.2', [ 'Q.3.a.2' , 'Q.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.14.a.3', [ 'Q.1.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.15.a.1', [ 'P.1.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.15.a.2', [ 'P.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.15.a.3', [ 'P.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.16.a.1', [ 'G.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.16.a.2', [ 'G.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.16.a.3', [ 'G.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.16.a.4', [ 'G.5.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.16.a.5', [ 'C.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.16.a.6', [ 'C.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.16.a.7', [ 'G.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.17.a.1', [ 'M.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.17.a.3', [ 'M.2.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.17.a.4', [ 'M.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.17.a.6', [ 'M.2.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.17.a.7', [ 'M.2.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.17.a.8', [ 'L.6.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.21.a.1', [ 'M.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '2.1.22.a.2', [ 'S.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '2.2.23.a.6', [ 'M.16.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.1.a.1', [ 'K.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.1.a.2', [ 'K.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.1.a.3', [ 'K.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.1.a.4', [ 'K.2.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.1.a.5', [ 'K.2.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.1.a.6', [ 'K.2.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.1.a.7', [ 'K.2.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.1.a.8', [ 'K.2.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.1', [ 'K.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.2', [ 'K.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.3', [ 'K.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.4', [ 'K.3.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.5', [ 'K.3.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.6', [ 'K.3.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.7', [ 'K.3.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.8', [ 'K.3.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.9', [ 'K.3.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.10', [ 'K.3.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.11', [ 'K.3.a.15' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.12', [ 'K.3.a.16' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.13', [ 'K.3.a.17' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.14', [ 'K.3.a.24' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.2.a.15', [ 'K.3.a.25' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.3.a.1', [ 'L.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.3.a.2', [ 'L.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.3.a.3', [ 'L.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.3.a.4', [ 'L.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.3.a.5', [ 'L.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.3.a.6', [ 'L.3.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.3.a.7', [ 'L.3.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.3.a.8', [ 'L.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.3.a.9', [ 'L.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.3.a.10', [ 'L.2.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.3.a.11', [ 'L.2.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.5.a.1', [ 'H.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.5.a.2', [ 'H.6.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.5.a.3', [ 'H.6.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.5.a.4', [ 'H.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.5.a.5', [ 'H.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.5.a.6', [ 'H.6.a.7' , 'H.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.5.a.7', [ 'C.9.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.5.a.8', [ 'C.9.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.6.a.1', [ 'B.4.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.6.a.2', [ 'C.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.6.a.3', [ 'G.13.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.6.a.4', [ 'G.13.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.6.a.5', [ 'G.13.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.6.a.6', [ 'G.13.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.6.a.7', [ 'G.13.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.6.a.8', [ 'G.13.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.6.a.9', [ 'G.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.1', [ 'D.3.a.1' , 'F.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.2', [ 'C.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.3', [ 'C.4.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.4', [ 'F.8.a.2' , 'F.8.a.3' , 'F.8.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.5', [ 'F.9.a.2' , 'F.10.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.6', [ 'G.5.a.1' , 'G.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.7', [ 'G.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.8', [ 'M.11.a.1' , 'G.5.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.9', [ 'G.5.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.10', [ 'M.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.11', [ 'E.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.12', [ 'A.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.7.a.13', [ 'M.16.a.1' , 'M.16.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.1', [ 'D.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.2', [ 'D.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.3', [ 'D.4.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.4', [ 'M.16.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.5', [ 'D.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.6', [ 'D.4.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.7', [ 'D.4.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.8', [ 'D.4.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.9', [ 'D.4.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.10', [ 'D.4.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.11', [ 'D.4.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.12', [ 'G.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.8.a.13', [ 'G.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.1', [ 'K.3.a.19' , 'K.3.a.20' , 'K.3.a.21' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.2', [ 'H.7.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.3', [ 'H.7.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.4', [ 'H.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.5', [ 'H.7.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.6', [ 'H.7.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.7', [ 'H.7.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.9', [ 'D.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.10', [ 'K.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.11', [ 'I.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.12', [ 'I.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.13', [ 'I.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.14', [ 'L.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.15', [ 'L.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.16', [ 'L.2.a.6' , 'L.2.a.7' , 'L.2.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.17', [ 'L.3.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.18', [ 'E.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.19', [ 'F.8.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.20', [ 'P.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.9.a.21', [ 'P.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.10.a.1.1', [ 'F.3.a.1' , 'F.3.a.2' , 'F.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.11.a.2.1', [ 'F.4.a.1' , 'F.4.a.2' , 'F.4.a.3' , 'F.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.12.a.3.1', [ 'F.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.13.a.1.1', [ 'F.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.14.a.2.1', [ 'M.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.15.a.3.1', [ 'M.14.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.1', [ 'F.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.2', [ 'F.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.3', [ 'F.6.a.7' , 'I.15.a.2' , 'I.15.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.4', [ 'F.6.a.5' , 'I.15.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.5', [ 'K.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.6', [ 'K.5.a.2' , 'K.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.8', [ 'H.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.9', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.10', [ 'D.3.a.5' , 'R.12.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.11', [ 'D.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.12', [ 'G.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.13', [ 'G.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.14', [ 'M.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.15', [ 'M.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.16', [ 'M.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.17', [ 'M.5.a.1' , 'M.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.16.a.18', [ 'M.5.a.2' , 'M.7.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.17.a.1', [ 'F.4.a.1' , 'F.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.17.a.2', [ 'F.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.17.a.3', [ 'F.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.1', [ 'G.3.a.3' , 'G.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.2', [ 'G.3.a.1' , 'G.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.3', [ 'C.3.a.1' , 'C.3.a.2' , 'C.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.4', [ 'C.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.5', [ 'H.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.6', [ 'H.3.a.2' , 'H.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.7', [ 'P.5.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.9', [ 'M.2.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.10', [ 'M.9.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.11', [ 'M.12.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.12', [ 'D.3.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.13', [ 'D.3.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.14', [ 'M.16.a.3' , 'D.3.a.7' , 'D.2.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.18.a.15', [ 'M.12.a.1' , 'M.12.a.2' , 'M.12.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.1', [ 'G.3.a.3' , 'G.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.2', [ 'G.3.a.1' , 'G.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.3', [ 'C.3.a.1' , 'C.3.a.2' , 'C.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.4', [ 'C.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.5', [ 'H.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.6', [ 'H.3.a.2' , 'H.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.7', [ 'P.5.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.9', [ 'M.2.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.10', [ 'M.9.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.11', [ 'M.12.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.12', [ 'D.3.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.13', [ 'D.3.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.14', [ 'F.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.15', [ 'F.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.16', [ 'F.6.a.7' , 'I.15.a.2' , 'I.15.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.17', [ 'F.6.a.5' , 'I.15.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.18', [ 'K.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.19', [ 'K.5.a.2' , 'K.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.21', [ 'H.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.22', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.23', [ 'D.3.a.5' , 'R.12.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.24', [ 'D.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.25', [ 'G.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.26', [ 'G.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.27', [ 'M.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.28', [ 'M.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.29', [ 'M.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.30', [ 'M.5.a.1' , 'M.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.31', [ 'M.5.a.2' , 'M.7.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.1.19.a.32', [ 'M.9.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.1', [ 'L.5.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.3', [ 'D.5.a.18' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.6', [ 'D.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.7', [ 'D.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.8', [ 'D.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.9', [ 'D.5.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.10', [ 'D.4.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.11', [ 'D.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.12', [ 'D.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.13', [ 'F.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.14', [ 'C.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.15', [ 'H.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.16', [ 'H.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.17', [ 'H.6.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.18', [ 'H.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.19', [ 'H.6.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.20', [ 'H.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.21', [ 'H.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.22', [ 'G.13.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.23', [ 'G.13.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.24', [ 'G.10.a.1' , 'G.10.a.2' , 'G.10.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.25', [ 'G.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.26', [ 'G.15.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.27', [ 'G.16.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.28', [ 'G.15.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.31', [ 'D.4.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.32', [ 'I.4.a.1' , 'I.4.a.2' , 'I.4.a.3' , 'I.4.a.4' , 'I.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.34', [ 'D.3.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.37', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '3.2.28.a.38', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.1.a.1', [ 'F.4.a.1' , 'F.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.1.a.2', [ 'F.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.1.a.3', [ 'F.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.2.a.1.1', [ 'F.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.3.a.1.1', [ 'M.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.4.a.1.1', [ 'M.14.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.5.a.1.1', [ 'F.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.1', [ 'G.3.a.3' , 'G.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.2', [ 'G.3.a.1' , 'G.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.3', [ 'C.3.a.1' , 'C.3.a.2' , 'C.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.4', [ 'C.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.5', [ 'H.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.6', [ 'H.3.a.2' , 'H.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.7', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.8', [ 'P.5.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.10', [ 'M.2.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.11', [ 'M.9.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.12', [ 'M.12.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.13', [ 'D.3.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.14', [ 'D.3.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.15', [ 'M.16.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.16', [ 'D.3.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.17', [ 'M.16.a.3' , 'D.2.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.18', [ 'M.12.a.1' , 'M.12.a.2' , 'M.12.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.6.a.19', [ 'M.12.a.1' , 'M.12.a.2' , 'M.12.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.7.a.1', [ 'M.14.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.7.a.2', [ 'H.7.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.7.a.3', [ 'H.7.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.7.a.6', [ 'M.11.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.1', [ 'F.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.2', [ 'F.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.3', [ 'F.6.a.7' , 'I.15.a.2' , 'I.15.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.4', [ 'F.6.a.5' , 'I.15.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.5', [ 'K.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.6', [ 'K.5.a.2' , 'K.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.8', [ 'H.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.9', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.10', [ 'D.3.a.5' , 'R.12.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.11', [ 'D.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.12', [ 'G.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.13', [ 'G.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.14', [ 'M.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.15', [ 'M.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.16', [ 'M.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.17', [ 'M.5.a.1' , 'M.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.8.a.18', [ 'M.5.a.2' , 'M.7.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.9.a.2', [ 'F.8.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.9.a.3', [ 'M.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.9.a.4', [ 'M.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.9.a.5', [ 'M.9.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.10.a.2', [ 'F.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.10.a.3', [ 'F.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.10.a.4', [ 'D.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.10.a.5', [ 'F.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.10.a.6', [ 'I.15.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.10.a.7', [ 'F.6.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.10.a.8', [ 'M.16.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.10.a.9', [ 'C.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.11.a.1', [ 'G.3.a.3' , 'G.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.11.a.2', [ 'G.3.a.1' , 'G.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.11.a.3', [ 'C.3.a.1' , 'C.3.a.2' , 'C.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.11.a.4', [ 'C.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.11.a.5', [ 'H.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.11.a.6', [ 'H.3.a.2' , 'H.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.11.a.7', [ 'P.5.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.11.a.9', [ 'M.2.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.11.a.10', [ 'M.9.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.11.a.11', [ 'M.12.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.11.a.12', [ 'D.3.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.11.a.13', [ 'D.3.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.1', [ 'F.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.2', [ 'F.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.3', [ 'F.6.a.7' , 'I.15.a.2' , 'I.15.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.4', [ 'F.6.a.5' , 'I.15.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.5', [ 'K.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.6', [ 'K.5.a.2' , 'K.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.8', [ 'H.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.9', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.10', [ 'D.3.a.5' , 'R.12.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.11', [ 'D.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.12', [ 'G.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.13', [ 'G.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.14', [ 'M.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.15', [ 'M.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.16', [ 'M.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.17', [ 'M.5.a.1' , 'M.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.18', [ 'M.5.a.2' , 'M.7.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.12.a.19', [ 'M.9.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.14.a.1', [ 'K.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.14.a.2', [ 'K.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.14.a.3', [ 'K.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.14.a.4', [ 'K.2.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.14.a.5', [ 'K.2.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.14.a.6', [ 'K.2.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.14.a.7', [ 'K.2.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.14.a.8', [ 'K.2.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.1', [ 'K.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.2', [ 'K.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.3', [ 'K.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.4', [ 'K.3.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.5', [ 'K.3.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.6', [ 'K.3.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.7', [ 'K.3.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.8', [ 'K.3.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.9', [ 'K.3.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.10', [ 'K.3.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.11', [ 'K.3.a.15' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.12', [ 'K.3.a.16' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.13', [ 'K.3.a.17' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.14', [ 'K.3.a.24' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.15.a.15', [ 'K.3.a.25' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.1', [ 'L.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.2', [ 'L.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.3', [ 'L.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.4', [ 'L.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.5', [ 'L.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.6', [ 'L.3.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.7', [ 'L.3.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.8', [ 'L.3.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.9', [ 'L.3.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.10', [ 'L.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.11', [ 'L.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.12', [ 'L.2.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.16.a.13', [ 'L.2.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.18.a.1', [ 'H.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.18.a.2', [ 'H.6.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.18.a.3', [ 'H.6.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.18.a.4', [ 'H.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.18.a.5', [ 'H.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.18.a.6', [ 'H.6.a.7' , 'H.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.18.a.7', [ 'C.9.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.18.a.8', [ 'C.9.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.19.a.1', [ 'B.4.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.19.a.2', [ 'C.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.19.a.3', [ 'G.13.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.19.a.4', [ 'G.13.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.19.a.5', [ 'G.13.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.19.a.6', [ 'G.13.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.19.a.7', [ 'G.13.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.19.a.8', [ 'G.13.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.1.19.a.9', [ 'G.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.3', [ 'L.5.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.7', [ 'D.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.8', [ 'E.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.9', [ 'D.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.12', [ 'A.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.13', [ 'A.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.15', [ 'D.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.16', [ 'D.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.17', [ 'D.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.19', [ 'I.12.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.20', [ 'D.5.a.5' , 'D.5.a.6' , 'D.5.a.7' , 'D.5.a.8' , 'D.5.a.9' , 'D.5.a.19' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.22', [ 'J.2.a.1' , 'J.2.a.2' , 'J.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.23', [ 'I.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.24', [ 'I.4.a.1' , 'I.4.a.2' , 'I.4.a.3' , 'I.4.a.4' , 'I.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '4.2.33.a.25', [ 'I.4.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.1.a.1.1', [ 'J.2.a.1' , 'J.2.a.2' , 'J.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.3.a.1', [ 'J.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.3.a.2', [ 'J.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.3.a.3', [ 'J.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.4.a.1', [ 'J.3.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.4.a.2', [ 'J.3.a.8' , 'J.3.a.1' , 'J.3.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.4.a.3', [ 'J.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.4.a.4', [ 'J.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.4.a.5', [ 'J.3.a.4' , 'J.3.a.5' , 'J.3.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.5.a.1', [ 'J.5.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.5.a.2', [ 'J.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.5.a.3', [ 'J.5.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.5.a.4', [ 'J.5.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.5.a.5', [ 'J.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.5.a.6', [ 'J.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.5.a.7', [ 'J.5.a.7' , 'J.5.a.8' , 'J.5.a.9' , 'J.5.a.10' , 'J.5.a.11' , 'J.5.a.12' , 'J.5.a.13' , 'J.5.a.14' , 'J.5.a.15' , 'J.5.a.16' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.6.a.1', [ 'J.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.6.a.2', [ 'J.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.6.a.3', [ 'J.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.6.a.4', [ 'J.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.6.a.5', [ 'J.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.6.a.6', [ 'J.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.6.a.7', [ 'J.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.6.a.8', [ 'J.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.6.a.9', [ 'J.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.6.a.10', [ 'J.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.6.a.11', [ 'J.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.6.a.12', [ 'J.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.8.a.1', [ 'I.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.8.a.2', [ 'I.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.8.a.3', [ 'I.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.8.a.4', [ 'I.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.8.a.5', [ 'I.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.8.a.6', [ 'I.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.8.a.7', [ 'I.8.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.9.a.1', [ 'I.7.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.9.a.2', [ 'I.7.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.9.a.3', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.9.a.4', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.9.a.5', [ 'I.8.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.9.a.6', [ 'I.8.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.10.a.1', [ 'I.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.10.a.2', [ 'I.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.10.a.3', [ 'I.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.10.a.4', [ 'I.5.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.10.a.5', [ 'L.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.10.a.6', [ 'L.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.10.a.7', [ 'J.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.10.a.8', [ 'J.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.10.a.9', [ 'J.6.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.10.a.10', [ 'J.6.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.11.a.1', [ 'I.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.11.a.2', [ 'I.6.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.11.a.3', [ 'I.10.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.11.a.4', [ 'I.10.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.15.a.1', [ 'I.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.15.a.2', [ 'I.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.15.a.3', [ 'I.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.15.a.4', [ 'I.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.15.a.5', [ 'I.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.15.a.6', [ 'I.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.15.a.7', [ 'I.8.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.16.a.1', [ 'I.7.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.16.a.2', [ 'I.7.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.16.a.3', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.16.a.4', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.16.a.5', [ 'I.8.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.16.a.6', [ 'I.8.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.17.a.1', [ 'I.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.17.a.2', [ 'I.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.17.a.3', [ 'I.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.17.a.4', [ 'I.5.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.17.a.5', [ 'L.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.17.a.6', [ 'L.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.17.a.7', [ 'J.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.17.a.8', [ 'J.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.17.a.9', [ 'J.6.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.17.a.10', [ 'J.6.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.18.a.1', [ 'I.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.18.a.2', [ 'I.6.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.18.a.3', [ 'I.10.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.18.a.4', [ 'I.10.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.19.a.1', [ 'I.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.19.a.2', [ 'J.5.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.19.a.3', [ 'J.5.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.19.a.4', [ 'J.5.a.15' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.23.a.1', [ 'I.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.23.a.2', [ 'I.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.23.a.3', [ 'I.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.23.a.4', [ 'I.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.23.a.5', [ 'I.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.23.a.6', [ 'I.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.23.a.7', [ 'I.8.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.24.a.1', [ 'I.7.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.24.a.2', [ 'I.7.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.24.a.3', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.24.a.4', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.24.a.5', [ 'I.8.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.24.a.6', [ 'I.8.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.25.a.1', [ 'I.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.25.a.2', [ 'I.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.25.a.3', [ 'I.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.25.a.4', [ 'I.5.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.25.a.5', [ 'L.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.25.a.6', [ 'L.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.25.a.7', [ 'J.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.25.a.8', [ 'J.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.25.a.9', [ 'J.6.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.25.a.10', [ 'J.6.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.26.a.1', [ 'I.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.26.a.2', [ 'I.6.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.26.a.3', [ 'I.10.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.26.a.4', [ 'I.10.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.29.a.1.1', [ 'J.6.a.1' , 'J.6.a.2' , 'J.6.a.3' , 'J.6.a.4' , 'J.6.a.5' , 'J.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.33.a.1', [ 'I.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.33.a.2', [ 'I.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.33.a.3', [ 'I.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.33.a.4', [ 'I.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.33.a.5', [ 'I.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.33.a.6', [ 'I.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.33.a.7', [ 'I.8.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.34.a.1', [ 'I.7.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.34.a.2', [ 'I.7.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.34.a.3', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.34.a.4', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.34.a.5', [ 'I.8.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.34.a.6', [ 'I.8.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.35.a.1', [ 'I.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.35.a.2', [ 'I.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.35.a.3', [ 'I.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.35.a.4', [ 'I.5.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.35.a.5', [ 'L.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.35.a.6', [ 'L.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.35.a.7', [ 'J.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.35.a.8', [ 'J.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.35.a.9', [ 'J.6.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.35.a.10', [ 'J.6.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.36.a.1', [ 'I.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.36.a.2', [ 'I.6.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.36.a.3', [ 'I.10.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.36.a.4', [ 'I.10.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.37.a.1.1', [ 'J.7.a.1' , 'J.7.a.2' , 'J.7.a.3' , 'J.7.a.4' , 'J.7.a.5' , 'J.7.a.6' , 'J.7.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.39.a.1', [ 'I.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.39.a.2', [ 'I.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.39.a.3', [ 'I.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.39.a.4', [ 'I.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.39.a.5', [ 'I.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.39.a.6', [ 'I.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.39.a.7', [ 'I.8.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.40.a.1', [ 'I.7.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.40.a.2', [ 'I.7.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.40.a.3', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.40.a.4', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.40.a.5', [ 'I.8.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.40.a.6', [ 'I.8.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.41.a.1', [ 'I.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.41.a.2', [ 'I.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.41.a.3', [ 'I.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.41.a.4', [ 'I.5.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.41.a.5', [ 'L.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.41.a.6', [ 'L.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.41.a.7', [ 'J.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.41.a.8', [ 'J.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.41.a.9', [ 'J.6.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.41.a.10', [ 'J.6.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.42.a.1', [ 'I.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.42.a.2', [ 'I.6.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.42.a.3', [ 'I.10.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.42.a.4', [ 'I.10.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.43.a.1', [ 'I.10.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.43.a.2', [ 'I.10.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.43.a.3', [ 'G.3.a.1' , 'G.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.43.a.5', [ 'F.6.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.43.a.6', [ 'F.6.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.43.a.7', [ 'F.6.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.43.a.8', [ 'I.7.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.43.a.9', [ 'I.8.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.44.a.2', [ 'G.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.44.a.3', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.44.a.5', [ 'D.3.a.2' , 'F.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.44.a.6', [ 'M.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.45.a.1.1', [ 'L.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.1.46.a.1.1', [ 'L.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.2.49.a.4', [ 'F.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.2.49.a.5', [ 'I.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.2.49.a.6', [ 'J.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '5.2.49.a.7', [ 'F.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.2.49.a.8', [ 'J.5.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '5.2.49.a.9', [ 'M.16.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '5.2.49.a.10', [ 'M.2.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '5.2.49.a.11', [ 'J.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '5.2.49.a.13', [ 'F.8.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '6.1.1.a.1', [ 'I.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '6.1.1.a.2', [ 'I.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '6.1.1.a.3', [ 'I.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '6.1.1.a.4', [ 'I.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '6.1.1.a.5', [ 'I.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '6.1.2.a.1', [ 'G.9.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '6.1.2.a.2', [ 'G.9.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '6.1.2.a.3', [ 'G.9.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '6.1.2.a.4', [ 'G.9.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '6.1.2.a.5', [ 'G.9.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '6.2.21.a.3', [ 'D.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '6.2.21.a.4', [ 'G.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.4.a.1', [ 'O.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.4.a.2', [ 'O.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.4.a.3', [ 'O.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.4.a.4', [ 'O.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.4.a.5', [ 'O.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.4.a.6', [ 'O.3.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.4.a.7', [ 'O.3.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.4.a.8', [ 'O.3.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.4.a.9', [ 'O.3.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.4.a.10', [ 'O.3.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.4.a.11', [ 'O.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.4.a.13', [ 'O.3.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.5.a.1', [ 'I.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.5.a.2', [ 'I.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.5.a.3', [ 'I.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.5.a.4', [ 'I.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.5.a.5', [ 'I.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.5.a.6', [ 'I.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.5.a.7', [ 'I.8.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.6.a.1', [ 'I.7.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.6.a.2', [ 'I.7.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.6.a.3', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.6.a.4', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.6.a.5', [ 'I.8.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.6.a.6', [ 'I.8.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.7.a.1', [ 'I.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.7.a.2', [ 'I.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.7.a.3', [ 'I.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.7.a.4', [ 'I.5.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.7.a.5', [ 'L.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.7.a.6', [ 'L.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.7.a.7', [ 'J.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.7.a.8', [ 'J.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.7.a.9', [ 'J.6.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.7.a.10', [ 'J.6.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.8.a.1', [ 'I.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.8.a.2', [ 'I.6.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.8.a.3', [ 'I.10.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.8.a.4', [ 'I.10.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.9.a.1', [ 'I.10.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.9.a.2', [ 'I.10.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.9.a.3', [ 'G.3.a.1' , 'G.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.9.a.5', [ 'F.6.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.9.a.6', [ 'F.6.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.9.a.7', [ 'F.6.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.9.a.8', [ 'I.7.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.9.a.9', [ 'I.8.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.2', [ 'G.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.3', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.5', [ 'D.3.a.2' , 'F.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.6', [ 'M.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.7', [ 'M.16.a.1' , 'M.16.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.8', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.9', [ 'P.1.a.3' , 'P.2.a.3' , 'P.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.10', [ 'D.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.11', [ 'D.2.a.1' , 'D.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.12', [ 'F.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.13', [ 'F.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.14', [ 'G.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.10.a.15', [ 'G.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.11.a.1.1', [ 'B.4.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.12.a.1', [ 'Q.8.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.14.a.1', [ 'Q.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.14.a.2', [ 'Q.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.15.a.1', [ 'M.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.15.a.2', [ 'M.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.15.a.3', [ 'D.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.15.a.4', [ 'D.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.15.a.5', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.15.a.6', [ 'B.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.1.15.a.7', [ 'G.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '7.2.19.a.2', [ 'B.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.2.19.a.5', [ 'Q.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.2.19.a.6', [ 'D.3.a.3' , 'F.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '7.2.19.a.7', [ 'D.3.a.1' , 'F.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '7.2.19.a.8', [ 'K.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.2.19.a.9', [ 'N.2.a.1' , 'N.2.a.2' , 'N.3.a.1' , 'N.6.a.1' , 'N.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '7.2.19.a.10', [ 'F.6.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '7.2.19.a.12', [ 'D.2.a.1' , 'D.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '8.1.1.a.1', [ 'Q.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '8.1.1.a.2', [ 'Q.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '8.1.5.a.1', [ 'Q.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '8.1.5.a.2', [ 'Q.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '8.1.9.a.1', [ 'B.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '8.1.9.a.2', [ 'B.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '8.1.11.a.1', [ 'I.16.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '8.1.14.a.1', [ 'G.19.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '8.1.14.a.2', [ 'G.19.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '8.1.14.a.3', [ 'G.19.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '8.1.16.a.1', [ 'G.17.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '8.2.25.a.1', [ 'D.4.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '8.2.25.a.3', [ 'D.5.a.19' ] ) );
  matchingRules.push( new Rule( 'A', '8.2.25.a.5', [ 'A.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '8.2.25.a.8', [ 'G.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '8.2.25.a.11', [ 'G.6.a.3' , 'G.6.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.1.a.1.1', [ 'I.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.2.a.1.1', [ 'I.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.3.a.1.1', [ 'I.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.4.a.1.1', [ 'I.4.a.2' , 'I.4.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.5.a.1.1', [ 'I.4.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.7.a.1.1', [ 'M.14.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.8.a.1.1', [ 'M.14.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.9.a.1', [ 'I.8.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.9.a.2', [ 'I.8.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.9.a.3', [ 'I.8.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.9.a.4', [ 'I.8.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.9.a.5', [ 'I.8.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.9.a.6', [ 'I.8.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.9.a.7', [ 'I.8.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.9.a.8', [ 'I.8.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.9.a.9', [ 'I.8.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.9.a.10', [ 'I.8.a.15' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.10.a.1', [ 'I.6.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.10.a.2', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.11.a.1', [ 'I.9.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.11.a.2', [ 'I.9.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.11.a.3', [ 'I.9.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.11.a.4', [ 'I.9.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.12.a.1', [ 'I.10.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.12.a.2', [ 'I.10.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.12.a.3', [ 'I.10.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.12.a.4', [ 'I.10.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.17.a.1', [ 'I.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.17.a.2', [ 'I.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.17.a.3', [ 'I.6.a.11' , 'I.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.17.a.4', [ 'I.8.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.17.a.5', [ 'I.6.a.9' , 'I.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.17.a.6', [ 'I.8.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.17.a.7', [ 'I.8.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.18.a.1', [ 'I.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.18.a.2', [ 'I.7.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.18.a.3', [ 'I.7.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.18.a.4', [ 'I.7.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.18.a.5', [ 'I.6.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.18.a.6', [ 'I.8.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.18.a.7', [ 'I.8.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.18.a.8', [ 'I.7.a.3' , 'I.8.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.18.a.9', [ 'I.8.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.18.a.10', [ 'I.9.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.18.a.11', [ 'I.9.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.18.a.12', [ 'I.8.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.23.a.1', [ 'D.3.a.2' , 'F.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.23.a.2', [ 'I.10.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.23.a.3', [ 'I.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.23.a.5', [ 'M.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '9.1.23.a.6', [ 'F.6.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '9.2.24.a.1', [ 'D.5.a.19' ] ) );
  matchingRules.push( new Rule( 'A', '9.2.24.a.2', [ 'M.8.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '9.2.24.a.4', [ 'D.3.a.1' , 'F.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.2.24.a.5', [ 'D.3.a.3' , 'F.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '9.2.24.a.8', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '9.2.24.a.9', [ 'H.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '9.2.24.a.12', [ 'F.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '9.2.24.a.13', [ 'D.3.a.1' , 'F.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '9.2.24.a.14', [ 'D.3.a.3' , 'F.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '9.2.24.a.15', [ 'M.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '10.1.5.a.1.1', [ 'I.12.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '10.1.7.a.1.1', [ 'I.8.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '10.1.11.a.1', [ 'J.8.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '10.1.15.a.1', [ 'J.8.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '11.1.1.a.1', [ 'M.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '11.1.1.a.2', [ 'M.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '11.1.1.a.3', [ 'M.2.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '11.1.2.a.1', [ 'M.2.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '11.1.2.a.2', [ 'M.2.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '11.1.2.a.3', [ 'M.2.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '11.1.3.a.1', [ 'M.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '11.1.3.a.2', [ 'M.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '11.1.5.a.1', [ 'M.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '11.2.18.a.1', [ 'F.6.a.10' , 'F.6.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '11.2.18.a.2', [ 'F.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '11.2.18.a.3', [ 'H.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '11.2.18.a.8', [ 'N.1.a.2' , 'N.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '11.2.18.a.10', [ 'D.3.a.2' , 'F.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.4.a.2', [ 'I.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.5.a.1.1', [ 'M.9.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.6.a.1.1', [ 'M.9.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.8.a.1', [ 'M.9.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.8.a.2', [ 'M.9.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.9.a.1.1', [ 'M.9.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.11.a.1.1', [ 'M.9.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.15.a.1.1', [ 'M.9.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.17.a.2', [ 'I.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.18.a.1.1', [ 'M.9.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.19.a.1.1', [ 'M.9.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.21.a.1', [ 'M.9.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.21.a.2', [ 'M.9.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.22.a.1.1', [ 'M.9.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.24.a.1.1', [ 'M.9.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '12.1.29.a.1.1', [ 'M.9.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.2.a.1', [ 'B.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.2.a.2', [ 'F.7.a.2' , 'F.10.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.2.a.3', [ 'S.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.2.a.4', [ 'D.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.5.a.1', [ 'D.5.a.16' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.5.a.2', [ 'D.5.a.17' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.5.a.3', [ 'D.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.5.a.7', [ 'I.11.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.6.a.1', [ 'M.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.6.a.2', [ 'D.4.a.6' , 'F.8.a.5' , 'F.8.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.6.a.5', [ 'M.9.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.6.a.7', [ 'I.11.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.8.a.1', [ 'D.2.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.8.a.3', [ 'F.8.a.1' , 'S.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.8.a.5', [ 'D.5.a.18' , 'F.8.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.8.a.6', [ 'B.5.a.2' , 'L.4.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.8.a.9', [ 'K.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.8.a.10', [ 'F.6.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.9.a.1', [ 'C.3.a.6' , 'D.5.a.6' , 'D.5.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.9.a.2', [ 'D.5.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.9.a.3', [ 'F.8.a.1' , 'F.8.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.9.a.4', [ 'D.5.a.19' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.9.a.5', [ 'A.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.9.a.6', [ 'I.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.10.a.2', [ 'I.11.a.3' , 'I.11.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.10.a.3', [ 'I.11.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.10.a.4', [ 'D.5.a.12' , 'D.5.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.10.a.5', [ 'I.11.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.10.a.7', [ 'D.5.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.11.a.1', [ 'J.7.a.1' , 'F.6.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.11.a.3', [ 'I.11.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.11.a.6', [ 'M.16.a.1' , 'M.16.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.12.a.5', [ 'I.11.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.12.a.6', [ 'D.3.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.13.a.1', [ 'O.3.a.1' , 'O.3.a.2' , 'O.3.a.3' , 'O.3.a.4' , 'O.3.a.5' , 'O.3.a.6' , 'O.3.a.7' , 'O.3.a.8' , 'O.3.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.1', [ 'D.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.2', [ 'D.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.3', [ 'M.16.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.4', [ 'F.6.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.5', [ 'F.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.6', [ 'F.6.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.7', [ 'D.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.8', [ 'B.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.9', [ 'D.3.a.2' , 'F.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.10', [ 'B.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.11', [ 'F.6.a.15' , 'F.6.a.16' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.13', [ 'M.16.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.17', [ 'M.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.18', [ 'L.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.19', [ 'D.5.a.15' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.20', [ 'F.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.15.a.21', [ 'F.8.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.19.a.1', [ 'N.2.a.1' , 'N.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.19.a.2', [ 'N.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.19.a.3', [ 'N.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.19.a.4', [ 'N.5.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.19.a.5', [ 'N.5.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.19.a.6', [ 'N.5.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.19.a.7', [ 'N.5.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.19.a.9', [ 'N.5.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.19.a.10', [ 'N.5.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.22.a.1.1', [ 'B.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.25.a.1.1', [ 'G.5.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.26.a.1', [ 'F.8.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.26.a.2', [ 'F.8.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.26.a.3', [ 'F.4.a.3' , 'D.4.a.5' , 'D.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.26.a.4', [ 'D.3.a.2' , 'F.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.26.a.5', [ 'D.2.a.1' , 'F.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.26.a.6', [ 'D.2.a.1' , 'D.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.26.a.7', [ 'D.3.a.1' , 'F.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.28.a.1', [ 'D.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.28.a.2', [ 'K.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.28.a.3', [ 'I.3.a.2' , 'I.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.28.a.4', [ 'I.11.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.29.a.1', [ 'H.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.29.a.2', [ 'H.7.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.29.a.3', [ 'H.7.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.30.a.1.1', [ 'M.8.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.30.a.1', [ 'M.9.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.30.a.2', [ 'I.13.a.4' , 'I.13.a.5' , 'I.13.a.6' , 'I.13.a.7' , 'I.13.a.8' , 'I.13.a.9' , 'I.13.a.10' , 'I.13.a.11' , 'I.13.a.12' , 'I.13.a.13' , 'I.13.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.32.a.2', [ 'I.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.33.a.1.1', [ 'D.3.a.2' , 'F.6.a.9' , 'F.8.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.34.a.1.1', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.35.a.1.1', [ 'M.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.1.38.a.1.1', [ 'I.4.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '13.2.39.a.1', [ 'D.3.a.2' , 'F.6.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '13.2.39.a.15', [ 'F.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '13.2.39.a.16', [ 'N.2.a.1' , 'N.2.a.2' , 'N.6.a.1' , 'N.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '13.2.39.a.17', [ 'F.8.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '13.2.39.a.18', [ 'I.4.a.3' , 'I.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '14.1.4.a.1.1', [ 'I.12.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '14.1.7.a.1.1', [ 'I.12.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '14.1.9.a.1.1', [ 'I.12.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '14.1.11.a.1.1', [ 'G.11.a.19' ] ) );
  matchingRules.push( new Rule( 'A', '14.1.12.a.1.1', [ 'I.12.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '15.1.1.a.1.1', [ 'I.13.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '16.1.1.a.1.1', [ 'I.13.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '16.1.2.a.1.1', [ 'I.13.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '16.1.3.a.1.1', [ 'I.13.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '16.1.6.a.1.1', [ 'I.13.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '16.1.8.a.1.1', [ 'I.13.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '16.1.11.a.1.1', [ 'I.13.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '16.1.13.a.1', [ 'I.13.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '16.1.13.a.2', [ 'I.13.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '17.1.2.a.1.1', [ 'I.16.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.2.a.1', [ 'R.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.2.a.2', [ 'R.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.2.a.3', [ 'R.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.2.a.4', [ 'R.2.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.2.a.5', [ 'Q.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.2.a.6', [ 'R.11.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.2.a.7', [ 'R.12.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.2.a.8', [ 'R.13.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.2.a.11', [ 'R.14.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.2.a.12', [ 'S.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.5.a.1.1', [ 'C.7.a.1' , 'C.7.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.6.a.1', [ 'C.7.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.6.a.2', [ 'C.7.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.6.a.3', [ 'C.7.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.6.a.4', [ 'C.7.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.6.a.5', [ 'C.7.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.8.a.1.1', [ 'E.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.1', [ 'E.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.2', [ 'E.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.3', [ 'E.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.4', [ 'E.2.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.5', [ 'E.2.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.6', [ 'E.2.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.7', [ 'E.2.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.8', [ 'E.2.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.9', [ 'E.2.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.10', [ 'E.2.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.11', [ 'E.2.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.12', [ 'E.2.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.13', [ 'E.2.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.9.a.14', [ 'E.2.a.15' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.11.a.1.1', [ 'E.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.12.a.1', [ 'E.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.12.a.2', [ 'E.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.12.a.3', [ 'E.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.12.a.4', [ 'E.4.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.12.a.5', [ 'E.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.12.a.6', [ 'E.4.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.14.a.1.1', [ 'R.7.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.1', [ 'R.8.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.2', [ 'R.8.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.3', [ 'R.8.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.4', [ 'R.8.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.5', [ 'R.8.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.6', [ 'R.8.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.7', [ 'R.8.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.8', [ 'R.8.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.9', [ 'R.8.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.10', [ 'R.8.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.11', [ 'R.8.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.12', [ 'R.8.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.13', [ 'R.8.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.14', [ 'R.8.a.15' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.15', [ 'R.8.a.16' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.16', [ 'R.8.a.17' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.17', [ 'R.8.a.18' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.15.a.18', [ 'R.8.a.19' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.17.a.1.1', [ 'R.9.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.18.a.1', [ 'R.10.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.18.a.2', [ 'R.10.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.18.a.3', [ 'R.10.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.20.a.1.1', [ 'R.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.21.a.1', [ 'R.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.21.a.2', [ 'R.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.21.a.3', [ 'R.6.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.21.a.4', [ 'R.6.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.21.a.5', [ 'R.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.22.a.1.1', [ 'R.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.23.a.1', [ 'R.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.23.a.2', [ 'R.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.23.a.3', [ 'R.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.23.a.4', [ 'R.4.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.23.a.5', [ 'R.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.23.a.6', [ 'R.4.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.23.a.7', [ 'R.4.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.23.a.8', [ 'R.4.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.23.a.9', [ 'R.4.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.25.a.1.1', [ 'G.18.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.1', [ 'G.19.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.2', [ 'G.19.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.3', [ 'G.19.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.4', [ 'G.19.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.5', [ 'G.19.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.6', [ 'G.19.a.22' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.7', [ 'G.19.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.8', [ 'G.19.a.20' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.9', [ 'G.19.a.21' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.10', [ 'G.19.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.11', [ 'G.19.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.12', [ 'G.19.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.13', [ 'G.19.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.14', [ 'G.19.a.15' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.15', [ 'G.19.a.16' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.16', [ 'G.19.a.17' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.17', [ 'G.19.a.18' ] ) );
  matchingRules.push( new Rule( 'A', '18.1.26.a.18', [ 'G.19.a.19' ] ) );
  matchingRules.push( new Rule( 'A', '18.2.28.a.5', [ 'C.7.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '18.2.28.a.8', [ 'D.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '18.2.28.a.9', [ 'D.5.a.16' ] ) );
  matchingRules.push( new Rule( 'A', '18.2.28.a.10', [ 'D.3.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '18.2.28.a.11', [ 'G.16.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '18.2.28.a.12', [ 'M.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '18.2.28.a.13', [ 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.2.28.a.14', [ 'G.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '18.2.28.a.15', [ 'G.3.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '18.2.28.a.20', [ 'F.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '18.2.28.a.22', [ 'G.17.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '18.2.28.a.23', [ 'G.17.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.1.a.1', [ 'E.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.1.a.2', [ 'E.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.2.a.1', [ 'A.7.a.1' , 'A.7.a.2' , 'A.7.a.3' , 'E.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.2.a.2', [ 'E.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.2.a.3', [ 'E.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.2.a.4', [ 'E.6.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.2.a.6', [ 'F.8.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.3.a.3', [ 'E.6.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.3.a.4', [ 'E.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.3.a.5', [ 'C.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.3.a.6', [ 'E.6.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.3.a.7', [ 'E.2.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.3.a.8', [ 'F.8.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.3.a.10', [ 'E.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.4.a.3', [ 'I.14.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.4.a.5', [ 'I.14.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.4.a.8', [ 'G.8.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.4.a.9', [ 'G.11.a.1' , 'G.11.a.2' , 'G.11.a.3' , 'G.11.a.4' , 'G.11.a.5' , 'G.11.a.6' , 'G.11.a.7' , 'G.11.a.8' , 'G.11.a.9' , 'G.11.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.4.a.10', [ 'G.11.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.4.a.11', [ 'G.11.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.4.a.12', [ 'G.11.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.4.a.13', [ 'G.11.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.4.a.14', [ 'G.11.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.4.a.15', [ 'G.11.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.4.a.16', [ 'G.11.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.5.a.1.1', [ 'G.3.a.3' , 'P.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.5.a.1', [ 'G.3.a.1' , 'G.3.a.2' , 'G.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.5.a.3', [ 'G.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.6.a.1', [ 'G.13.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.6.a.3', [ 'G.11.a.15' , 'G.11.a.16' , 'G.11.a.17' , 'G.11.a.18' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.9.a.2', [ 'G.19.a.1' , 'G.19.a.2' , 'G.19.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.9.a.4', [ 'G.5.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.10.a.1', [ 'E.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.10.a.2', [ 'E.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.1.10.a.6', [ 'M.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '19.2.11.a.1', [ 'J.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.2.11.a.2', [ 'J.2.a.1' , 'J.2.a.2' , 'J.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '19.2.11.a.3', [ 'M.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.2.11.a.4', [ 'M.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '19.2.11.a.6', [ 'D.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '19.2.11.a.9', [ 'G.19.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.1.a.1', [ 'P.5.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.1.a.2', [ 'P.5.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.1.a.3', [ 'P.5.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.1.a.4', [ 'P.5.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.1.a.5', [ 'P.5.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.2.a.1', [ 'G.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.2.a.1', [ 'G.4.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.2.a.2', [ 'G.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.2.a.3', [ 'G.4.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.2.a.4', [ 'G.4.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.2.a.5', [ 'G.4.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.3.a.1', [ 'G.4.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.3.a.2', [ 'G.4.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.3.a.3', [ 'G.4.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.4.a.1', [ 'P.5.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.4.a.2', [ 'P.5.a.15' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.4.a.3', [ 'P.5.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.4.a.4', [ 'P.5.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.5.a.1', [ 'G.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.5.a.2', [ 'G.4.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.5.a.3', [ 'G.4.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.5.a.4', [ 'G.4.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.5.a.5', [ 'G.4.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.10.a.2', [ 'D.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.10.a.7', [ 'D.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.10.a.8', [ 'D.5.a.17' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.1', [ 'D.3.a.1' , 'F.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.3', [ 'M.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.4', [ 'M.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.5', [ 'F.6.a.5' , 'I.15.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.6', [ 'F.6.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.7', [ 'M.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.8', [ 'M.4.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.9', [ 'D.3.a.3' , 'F.6.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.10', [ 'D.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.11', [ 'I.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.12', [ 'G.8.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.13', [ 'L.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.14', [ 'L.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.15', [ 'J.2.a.1' , 'J.2.a.2' , 'J.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '20.1.11.a.16', [ 'I.4.a.1' , 'I.4.a.2' , 'I.4.a.3' , 'I.4.a.4' , 'I.4.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '20.2.12.a.1', [ 'D.2.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '20.2.12.a.2', [ 'R.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '20.2.12.a.3', [ 'G.18.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '20.2.12.a.4', [ 'E.1.a.2' , 'E.3.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '20.2.12.a.6', [ 'F.6.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '20.2.12.a.9', [ 'D.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '20.2.12.a.13', [ 'D.2.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '20.2.12.a.14', [ 'D.6.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '21.1.1.a.1.1', [ 'J.7.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '21.1.2.a.1.1', [ 'J.7.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '21.1.3.a.1.1', [ 'J.7.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '21.1.6.a.1.1', [ 'J.7.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '21.1.7.a.1.1', [ 'M.2.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '21.1.8.a.1', [ 'I.8.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '21.1.8.a.2', [ 'I.8.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '21.1.8.a.4', [ 'I.8.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '21.1.10.a.1.1', [ 'J.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '21.1.14.a.3', [ 'F.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '21.1.14.a.4', [ 'M.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '21.1.14.a.6', [ 'D.5.a.19' ] ) );
  matchingRules.push( new Rule( 'A', '22.1.1.a.1.1', [ 'C.4.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '22.1.2.a.1.1', [ 'E.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '22.1.3.a.1.1', [ 'E.5.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '22.1.6.a.1', [ 'F.8.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '22.1.6.a.3', [ 'D.2.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '22.1.6.a.4', [ 'D.3.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '22.1.6.a.5', [ 'B.3.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '22.1.10.a.2', [ 'D.5.a.19' ] ) );
  matchingRules.push( new Rule( 'A', '22.2.12.a.1', [ 'J.2.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '22.2.12.a.3', [ 'D.5.a.16' ] ) );
  matchingRules.push( new Rule( 'A', '22.2.12.a.5', [ 'F.8.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.1.a.1.1', [ 'G.14.a.1' , 'G.14.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.2.a.1', [ 'G.15.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.2.a.2', [ 'G.15.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.2.a.3', [ 'G.15.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.2.a.4', [ 'G.15.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.3.a.1', [ 'G.15.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.3.a.2', [ 'G.15.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.3.a.3', [ 'G.15.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.3.a.4', [ 'G.15.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.3.a.5', [ 'G.15.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.4.a.1', [ 'G.16.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.4.a.2', [ 'G.16.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.4.a.3', [ 'G.16.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.4.a.4', [ 'G.16.a.7' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.5.a.1', [ 'G.16.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.5.a.2', [ 'G.16.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.5.a.3', [ 'G.16.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.6.a.1.1', [ 'G.10.a.1' , 'G.10.a.2' , 'G.10.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.1', [ 'G.11.a.11' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.2', [ 'G.11.a.12' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.3', [ 'G.11.a.13' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.4', [ 'G.11.a.19' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.5', [ 'G.11.a.21' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.6', [ 'G.11.a.8' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.7', [ 'G.11.a.9' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.8', [ 'G.11.a.10' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.9', [ 'G.11.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.10', [ 'G.11.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.11', [ 'G.11.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.12', [ 'G.11.a.4' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.13', [ 'G.11.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.7.a.14', [ 'G.11.a.6' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.8.a.1', [ 'G.11.a.14' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.8.a.2', [ 'G.11.a.15' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.8.a.3', [ 'G.11.a.16' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.8.a.4', [ 'G.11.a.17' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.8.a.5', [ 'G.11.a.18' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.9.a.1', [ 'C.8.a.1' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.9.a.2', [ 'C.8.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.9.a.3', [ 'C.8.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '23.1.11.a.1.1', [ 'C.9.a.5' ] ) );
  matchingRules.push( new Rule( 'A', '23.2.13.a.1', [ 'G.13.a.3' ] ) );
  matchingRules.push( new Rule( 'A', '23.2.13.a.3', [ 'I.1.a.2' ] ) );
  matchingRules.push( new Rule( 'A', '23.2.13.a.4', [ 'I.2.a.2' ] ) );
    
  }
  
  // dont load hardcoded rules anymore
  // loadRules();
  



  return {
    
    /**
     *  
     * 
     * @param DomainResource rulesResource
     * @return void
     */
    addRulesFromConceptMap : function( rulesResource ){
      let json = rulesResource.toObject();

      for( var i in json.group ){
        for( var j in json.group[ i ].element ){
            let ruleElement = json.group[ i ].element[ j ];
            this.addConceptMapRuleElement( ruleElement );
        }
      }
      
    },


    /**
     * create hint rules based on json like: 
     * 
      {
          "code": "Q.4.a.3",
          "target": [ {
                  "code": "1.1.1.a.1",
                  "display": "immediate retention and recall",
                  "equivalence": "equivalent",
                  "product": [ {
                          "system": "http://documental.ee/fhir/codesystem/agree-disagree-nae",
                          "value": "NAE"
                    }
                ]
            }
          ]
      }
     * 
     * @param object ruleElement
     * @return void
     */
    addConceptMapRuleElement : function( ruleElement ){
      
      
      //console.log( ruleElement );
      //console.log( ruleElement.target );

      for( var k in ruleElement.target ){
        let targetAnswerCode = '';
        if( typeof ruleElement.target[ k ].product != 'undefined' ){
          for( var n in ruleElement.target[ k ].product ){
            targetAnswerCode = ruleElement.target[ k ].product[ n ].value;
          }
        }
        
        if( targetAnswerCode != '' ){
          matchingRules.push( new Rule( targetAnswerCode, ruleElement.target[ k ].code, [ ruleElement.code ] ) );

          // to match back from checklist o Mental status - remove end of the option value to get original linkId for that question
          //  matchingRules.push( new Rule( 'A', ruleElement.code, [ 'H.6.a.7' , 'H.6.a.8' ] ) );
        }
      }

    },

    
    /**
     * Clear whole cache for one questionnaire. Currently there will be only 
     * assessment-mental-status-v1 questionnaire answers here. 
     * 
     * @param string questionnaireId
     * @return void
     */
    clearAnswersCacheForQuestionnaire : function( questionnaireId ){
      cachedAnswers = [];
    },


    /**
     * 
     * @return array
     */
    getCachedHints : function(){
      return cachedHints.getAllAsArray();
    },

    
    /**
     * Currently not using questionnaireId since only 
     * mental status is currently for source of answers
     * 
     * @param string questionnaireId
     * @param array answers
     * @return void
     */
    addAnswers : function( questionnaireId, answers ){
      
      for( var i in answers ){
        cachedAnswers.push( answers[i] );
      }

      // reload all hints based on new answer
      cachedHints = null;
      cachedHints = new KeyValueCache();
      
      // search matches and cache hints
      for( var i in matchingRules ){
        var tmpRule = matchingRules[ i ];
        
        var tmpAnswerId = tmpRule.answerPresentInSourceIds( cachedAnswers );
        
        if( tmpAnswerId ){

          if( !cachedHints.keyExists( tmpRule.getDestId() ) ){
            var hint = new Hint( true );
            hint.setSourceId( tmpAnswerId );
            hint.setValueBoolean( true );
            hint.setValueString( tmpRule.getDestAnswerValue() );
            hint.setDestinationId( tmpRule.getDestId() );
            cachedHints.set( tmpRule.getDestId(), hint );
          }

        }

      }
      
    },

    
    /**
     * - 
     *
     * @param string id
     * @return string
     */
    findHintByQuestionId : function( id ){
      
      var result = new Hint( false );
      
      if( cachedHints.keyExists( id ) ){
        return cachedHints.get( id );
      }

      /*
      if( id == '1.1.1.a.3' ){
        result.setSourceId( 'xxxx' );
        result.setValueBoolean( true );
        result.setValueString( 'A' );
      }

      if( id == '1.1.1.a.1' ){
        result.setSourceId( 'yyyy' );
        result.setValueString( 'D' );
      }

      if( id == '1.1.4.a.2' ){
        result.setSourceId( 'H.79.a.2' );
        result.setValueString( 'A' );
        result.setValueBoolean( true );
      }

      if( id == '1.1.7.a.2' ){
        result.setSourceId( 'xxxx' );
        result.setValueBoolean( true );
        result.setValueString( 'A' );
      }
      
      cachedAnswers
      */


      return result;
    }

  };

};


export default AnswerHintsFromMentalStatus;